import SwitchBase from "./styled";
import { FormControlLabel } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

interface CustomizedSwitchProps {
  labelNotRequired?: boolean;
  checked: boolean;
  changeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      margin: 0,
    },
  })
);

export default function CustomizedSwitch({
  changeHandler,
  checked,
  labelNotRequired = true,
}: CustomizedSwitchProps) {
  const classes = useStyles();

  return (
    <FormControlLabel
      classes={{ root: classes.root }}
      control={<SwitchBase changeHandler={changeHandler} checked={checked} />}
      label={labelNotRequired ? "" : checked ? "Yes" : "No"}
    />
  );
}
